module.exports = __webpack_public_path__ + "static/media/ogimpact-pricing.7542aaac.jpg";